/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { ACTION_TYPES } from '../actions/ActionTypes';

export const initialState = {
  loading: false,
  userData: null,
  isAuthenticated: false,
  accessToken: null,
  userId: '',
  key:''
}

const Auth  = (state = initialState, { type, payload }) => {
  switch(type){

    case ACTION_TYPES.FETCH_USER_DATA:
      return {...state, userData: payload }

      case ACTION_TYPES.SET_IES_INFO:
      return {...state, ...payload }

      case ACTION_TYPES.FETCH_FUSION_DATA:
        return { ...state,key:payload }      

    default:
      return { ...state }
  }
}

export default Auth;